export const name = 'CounterWizardController';
export default function CounterWizardController($mdDialog, $scope, $log, presetsService, L10NFilter, errorDialogOpen) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  vm.showProgressBar = false;
  vm.knownProgress = false;
  vm.numberOfRecordsType = 'numberOfRecords';
  vm.firstRecord = 1;
  vm.step = 1;
  vm.numOfRecords = 100;
  vm.createDatabase = createDatabase;
  vm.validateLastRecord = validateLastRecord;
  vm.cancel = cancel;

  function createDatabase(){

    let data = ['Counter'];
    let lastRecord = vm.numOfRecords;
    if(vm.numberOfRecordsType === 'numberOfRecords'){
      lastRecord = Math.ceil(vm.numOfRecords * vm.step + vm.firstRecord - 1);
    }
    if(vm.firstRecord > lastRecord){
      return;
    }
    for(let i = vm.firstRecord; i <= lastRecord; i += vm.step){
      data.push(i);
    }

    if(data.length === 0){
      errorDialogOpen.openErrorDialog();
      $mdDialog.cancel();
    }
    $mdDialog.hide({
      data: data.join('\n')
    });
  }

  function validateLastRecord(counterWizardForm){
    if(vm.numberOfRecordsType === 'lastRecord') {
      if (vm.firstRecord > vm.numOfRecords) {
        counterWizardForm.records.$setValidity('validationError', false);
      } else {
        counterWizardForm.records.$setValidity('validationError', true);
      }
    }else{
      counterWizardForm.records.$setValidity('validationError', true);
    }
  }

  function cancel(){
    $mdDialog.cancel();
  }
}
